import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import BrandMark from '../common/BrandMark';

export default function Footer() {
  return (
    <footer className="bg-navy text-creamDark pt-20 pb-10 border-t-[8px] border-saddle">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-4 mb-8">
              <BrandMark className="w-12 h-12 text-brass opacity-80" />
              <div className="flex flex-col">
                <h4 className="font-serif text-2xl text-cream tracking-wide">Harbor & Hide</h4>
                <span className="font-sans text-[9px] tracking-[0.3em] uppercase text-brass">Est. 2018 | Workshop Goods</span>
              </div>
            </div>
            <p className="font-sans text-sm text-creamDark/60 max-w-sm leading-relaxed mb-8">
              Handcrafting heirloom-quality leather goods that bridge the gap between rugged durability and refined aesthetics. Every piece is cut, punched, and stitched by hand in our workshop.
            </p>
            <div className="flex gap-4">
              <button className="w-10 h-10 rounded-full border border-cream/10 flex items-center justify-center hover:bg-brass transition-colors">
                <SafeIcon icon={FiIcons.FiInstagram} className="w-4 h-4" />
              </button>
              <button className="w-10 h-10 rounded-full border border-cream/10 flex items-center justify-center hover:bg-brass transition-colors">
                <SafeIcon icon={FiIcons.FiFacebook} className="w-4 h-4" />
              </button>
              <button className="w-10 h-10 rounded-full border border-cream/10 flex items-center justify-center hover:bg-brass transition-colors">
                <SafeIcon icon={FiIcons.FiTwitter} className="w-4 h-4" />
              </button>
            </div>
          </div>
          
          <div>
            <h4 className="font-sans text-[11px] tracking-[0.25em] uppercase text-brass mb-8">Collections</h4>
            <ul className="space-y-4 font-sans text-xs">
              <li><Link to="/shop" className="text-creamDark/70 hover:text-cream transition-colors uppercase tracking-widest">The Bag Collection</Link></li>
              <li><Link to="/shop" className="text-creamDark/70 hover:text-cream transition-colors uppercase tracking-widest">Small Leather Goods</Link></li>
              <li><Link to="/builder" className="text-creamDark/70 hover:text-cream transition-colors uppercase tracking-widest">Daily Carry Kits</Link></li>
              <li><Link to="/gift-guide" className="text-creamDark/70 hover:text-cream transition-colors uppercase tracking-widest">The Gift Registry</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-sans text-[11px] tracking-[0.25em] uppercase text-brass mb-8">Workshop</h4>
            <ul className="space-y-4 font-sans text-xs">
              <li><Link to="/support" className="text-creamDark/70 hover:text-cream transition-colors uppercase tracking-widest">Care & Maintenance</Link></li>
              <li><Link to="/support" className="text-creamDark/70 hover:text-cream transition-colors uppercase tracking-widest">Shipping Policies</Link></li>
              <li><Link to="/support" className="text-creamDark/70 hover:text-cream transition-colors uppercase tracking-widest">Workshop FAQ</Link></li>
              <li><Link to="/support" className="text-creamDark/70 hover:text-cream transition-colors uppercase tracking-widest">Contact Artisan</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-cream/10 pt-10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="font-sans text-[9px] uppercase tracking-[0.2em] text-creamDark/40">
            &copy; {new Date().getFullYear()} Harbor & Hide Workshop. All Rights Reserved.
          </p>
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
            <p className="text-center" style={{ textTransform: 'none' }}><span>Made by </span><a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>DigLab.ai</a><span> and </span><a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>LingLinkAI.cn</a></p>
          </div>
        </div>
      </div>
    </footer>
  );
}